// extracted by mini-css-extract-plugin
export default {"wrapper":"vp-z","response":"wp-z","error":"xp-z","disabled":"yp-z","buttons":"zp-z","feedbackQuestionSection":"Ap-z","yesNoWrapper":"Bp-z"};